import { motion } from "motion/react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <motion.footer
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6 }}
      className="bg-gray-50"
    >
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {/* Logo & tagline */}
          <div>
            <img
              src="https://static.readdy.ai/image/df75ddbe126af1b251cb2de8db121689/e992db2f17549b17d89e0fba7cbc007b.jpeg"
              alt="Fiber One"
              loading="lazy"
              className="h-8 w-auto mb-4"
              width={250}
              height={95}
            />
            <p className="text-sm text-gray-600 leading-relaxed">
              Premiere Audio Visual System and AI Solutions Integrator headquartered in Singapore, operating across 4 countries.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-4 uppercase tracking-wide">
              Quick Links
            </h4>
            <ul className="space-y-2">
              {[
                { label: "Home", to: "/" },
                { label: "About", to: "/about" },
                { label: "Solutions", to: "/solutions" },
                { label: "Contact", to: "/contact" },
                { label: "Privacy Policy", to: "/privacy-policy" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-gray-600 hover:text-accent transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-4 uppercase tracking-wide">
              Get in Touch
            </h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-phone-line text-accent" />
                <span>+65 6635 2366</span>
              </li>
              <li>
                <a
                  href="mailto:sales.sg@fiberoneglobal.com"
                  className="flex items-center gap-2 text-sm text-gray-600 hover:text-accent transition-colors duration-200"
                >
                  <i className="ri-mail-line text-accent" />
                  <span>sales.sg@fiberoneglobal.com</span>
                </a>
              </li>
              <li className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-map-pin-line text-accent mt-0.5" />
                <span>No 1 Irving Place #08-13, The Commerze @ Irving, Singapore 369546</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="bg-accent">
        <div className="w-full px-4 md:px-8 lg:px-12 py-4">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3">
            <p className="text-sm text-white/80 text-center md:text-left">
              Copyright 2021 Fiber One Pte Ltd. All Rights Reserved
            </p>
            <p className="text-sm font-medium text-white tracking-wide">
              Vision for Tomorrow
            </p>
          </div>
        </div>
      </div>
    </motion.footer>
  );
}